import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL || 'http://localhost:8000/api', // Replace with your actual base API URL
    headers: {
        'Content-Type': 'application/json',
    },
});

// Optional: Set up interceptors for request and response handling
/** Exported so pages can attach the same token in JSON body when proxies strip Authorization. */
export function getAuthToken() {
    const raw =
        localStorage.getItem('auth_token') ||
        sessionStorage.getItem('auth_token') ||
        '';
    const t = typeof raw === 'string' ? raw.trim() : '';
    return t.replace(/^Bearer\s+/i, '').trim();
}

axiosInstance.interceptors.request.use(
    (config) => {
        const token = getAuthToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            // Fallback when server/proxy strips Authorization (Apache, some hosts)
            config.headers['X-Auth-Token'] = token;
            config.headers['X-Access-Token'] = token;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Avoid noisy logs when the app will show the API message (e.g. session expired).
            if (process.env.NODE_ENV === 'development') {
                console.warn('API returned 401:', error.config?.url);
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;